import { createISOStrDateUtil, getObjectUtil } from 'packages/src'
import { REDUX_STATUS } from '../constants'
import { getIdReduxUtil } from './get-id'
import { REDUX_DOMAIN_LIST_KEY, REDUX_KEY } from '../constants/key'

export function isSavingReduxUtil (instance) {
  return getObjectUtil(instance, 'status') === REDUX_STATUS.SAVING
}

export function isTemporaryIdReduxUtil (id) {
  return id < 0
}

export function isNewReduxUtil (instance) {
  const id = getIdReduxUtil(instance)
  return !id || isTemporaryIdReduxUtil(id)
}

export function createDomainListReduxUtil () {
  const now = createISOStrDateUtil()
  return {
    [REDUX_KEY.DATA]: [],
    [REDUX_KEY.STATUS]: null,
    [REDUX_DOMAIN_LIST_KEY.LAST_ID]: null,
    [REDUX_KEY.CREATED_AT]: now,
    [REDUX_KEY.UPDATED_AT]: now
  }
}

export * from './get-id'
export * from './get-value'
export * from './get-path'
export * from './get-data-path'
export * from './get-default-domain-list-path'
